<template>
  <div id="bigdata">
    <div class="banner">

    </div>
    <div class="feature mainWidth">
        <mu-row gutter class="feature_box">
          <mu-col width="50" tablet="50" desktop="50">
              <div class="feature_img">
                <img :src="$t('service.bigdata.foundImg')" alt="">
              </div>
          </mu-col>
          <mu-col width="50" tablet="50" desktop="50">
               <div class="feature_intro">
                 <div class="feature_title">{{$t('service.bigdata.meritsTitle')}}</div>
                 <mu-col class="" width="100" tablet="100" desktop="100"  v-for="item in $t('service.bigdata.merits')" :key="item">
                   <div class="merits">
                     <span class="merits_icon"></span><span class="merits_item">{{item}}</span>
                   </div>
                 </mu-col>
               </div>
          </mu-col>
        </mu-row>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'erange',
    data () {
      return {
        activeTab:'0',
      }
    },
    created(){

    },
    methods:{
      changeTab(idx){  //tab切换
        this.activeTab=idx;
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  #bigdata{
    padding-bottom: 60px;
    .banner{
      height:212px;
      margin:0 auto;
      background:url("../../../static/banner-data.png") no-repeat center center;
      background-size:auto 100%;
    }
    .feature_box{
      padding:100px 0px;
      overflow:hidden;
      background:#FFF;
      .feature_img{
        width:372px;
        height:239px;
        float:right;
        margin-right:20px;
        >img{
          width:inherit;
          height:inherit;
        }
      }
      .feature_intro{
        margin-left:20px;
        .feature_title{
          display:inline-block;
          min-width:90px;
          font-family: PingFangSC-Regular;
          font-size:24px;
          color: #3B3B3B;
          letter-spacing: 0;
          padding-bottom:20px;
          border-bottom:2px solid #6FA0FF;
          margin-bottom:20px;
        }
        .merits{
          .merits_icon{
            display: inline-block;
            width:13px;
            height:13px;
            background: url("../../../static/star-1.png") no-repeat center center;
            background-size: 100% 100%;
            margin-right:8px;
            vertical-align: middle;
          }
          .merits_item{
            display:inline-block;
            font-family: PingFangSC-Medium;
            font-size: 14px;
            color:#3B3B3B;
            letter-spacing: 0;
            line-height: 34px;
            font-weight: 600;
            vertical-align: middle;
          }
        }
      }
    }


  }

</style>




// WEBPACK FOOTER //
// src/page/childrens/bigdata.vue